import React, { useContext, useRef } from "react";
import ProductsData from "./ProductsData";
import CategoriesData from "./CategoriesData";
import { Link } from "react-router-dom";
import { SingleCategoryPageContextStart } from "../Context/SingleCategoryPageContext";

export default function ShopHeader(props) {

  const { setCategoryDetail } = useContext(SingleCategoryPageContextStart)

  // Looping products and categories for filters
  let filteredCategoriesWithCount = [];
  let filteredCategoryCounter = 0;
  for (let i = 0; i < CategoriesData.length; i++) {
    for (let j = 0; j < ProductsData.length; j++) {
      if (ProductsData[j].pCategory.toLowerCase().includes(CategoriesData[i].cTitle.toLowerCase())) {
        filteredCategoryCounter++;
      }
    }
    filteredCategoriesWithCount.push([CategoriesData[i].cTitle, filteredCategoryCounter]);
    filteredCategoryCounter = 0
  }

  const settingCategoryPageContextValue = (categoryName) => {
    setCategoryDetail(categoryName);
    localStorage.setItem("category", categoryName);
  }

  const bodyOverlay = useRef("");
  const slideInFilters = useRef("");

  let openFilters = () => {
    bodyOverlay.current.classList.add("body-overlay-active");
    slideInFilters.current.classList.add("slide-in-cart-active");
  }

  let closeFilters = () => {
    bodyOverlay.current.classList.remove("body-overlay-active");
    slideInFilters.current.classList.remove("slide-in-cart-active");
  }
  return (
    <>
      <div className="container-fluid home-container shop-header-container">
        <div className="d-flex justify-content-md-between justify-content-center gap-3 align-items-center pt-md-5 pb-md-4 shop-header">
          <div className="shop-header-side-one">
            <button onClick={openFilters} className="btn rounded-0 d-flex gap-2 justify-content-center align-items-center">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                <path d="M496 384H160v-16c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16v16H16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h80v16c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-16h336c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16zm0-160h-80v-16c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16v16H16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h336v16c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-16h80c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16zm0-160H288V48c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16v16H16C7.2 64 0 71.2 0 80v32c0 8.8 7.2 16 16 16h208v16c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-16h208c8.8 0 16-7.2 16-16V80c0-8.8-7.2-16-16-16z"></path>
              </svg>
              <span className="fw-semibold d-none d-sm-inline">Filter</span>
            </button>
          </div>
          <div className="shop-header-side-two d-flex gap-3 align-items-center">
            <div className="search d-flex gap-1">
              <input
                type="text"
                className="form-control rounded-0"
                name="search-product"
                placeholder="Search"
                value={props.searchValue}
                onChange={props.searchEventHandler}
              />
              <button className="btn rounded-0">
                <i className="fa-solid fa-magnifying-glass"></i>
              </button>
            </div>
            {/* <div className="product-views d-flex gap-2">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                <path d="M296 32h192c13.255 0 24 10.745 24 24v160c0 13.255-10.745 24-24 24H296c-13.255 0-24-10.745-24-24V56c0-13.255 10.745-24 24-24zm-80 0H24C10.745 32 0 42.745 0 56v160c0 13.255 10.745 24 24 24h192c13.255 0 24-10.745 24-24V56c0-13.255-10.745-24-24-24zM0 296v160c0 13.255 10.745 24 24 24h192c13.255 0 24-10.745 24-24V296c0-13.255-10.745-24-24-24H24c-13.255 0-24 10.745-24 24zm296 184h192c13.255 0 24-10.745 24-24V296c0-13.255-10.745-24-24-24H296c-13.255 0-24 10.745-24 24v160c0 13.255 10.745 24 24 24z"></path>
              </svg>

              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                <path d="M149.333 216v80c0 13.255-10.745 24-24 24H24c-13.255 0-24-10.745-24-24v-80c0-13.255 10.745-24 24-24h101.333c13.255 0 24 10.745 24 24zM0 376v80c0 13.255 10.745 24 24 24h101.333c13.255 0 24-10.745 24-24v-80c0-13.255-10.745-24-24-24H24c-13.255 0-24 10.745-24 24zM125.333 32H24C10.745 32 0 42.745 0 56v80c0 13.255 10.745 24 24 24h101.333c13.255 0 24-10.745 24-24V56c0-13.255-10.745-24-24-24zm80 448H488c13.255 0 24-10.745 24-24v-80c0-13.255-10.745-24-24-24H205.333c-13.255 0-24 10.745-24 24v80c0 13.255 10.745 24 24 24zm-24-424v80c0 13.255 10.745 24 24 24H488c13.255 0 24-10.745 24-24V56c0-13.255-10.745-24-24-24H205.333c-13.255 0-24 10.745-24 24zm24 264H488c13.255 0 24-10.745 24-24v-80c0-13.255-10.745-24-24-24H205.333c-13.255 0-24 10.745-24 24v80c0 13.255 10.745 24 24 24z"></path>
              </svg>
            </div> */}
          </div>
        </div>
      </div>


      {/* Body Overlay */}
      <div ref={bodyOverlay} className="body-overlay"></div>

      {/* Filters */}
      <div ref={slideInFilters} className="slide-in-filters col-lg-3 col-md-5 col-sm-7 col-12">
        <div className="slide-in-cart-header d-flex justify-content-between">
          <p className="p-0 m-0 fw-medium filters-heading">Filters</p>
          <p className="p-0 m-0">
            <i onClick={closeFilters} className="fa-solid fa-x"></i>
          </p>
        </div>
        <div className="slide-in-filters-product-category">
          <h5 className="mb-4">Product Categories</h5>
          <div className="filters-product-categories d-flex flex-column gap-2">
            {filteredCategoriesWithCount.map((singleCategory) => {
              return (
                <Link onClick={() => { settingCategoryPageContextValue(singleCategory[0]) }} key={singleCategory[0]} to={`/category`}>{singleCategory[0]} <span>({singleCategory[1]})</span></Link>
              )
            })}

          </div>
        </div>
      </div>
    </>
  );
}
